<template>
  <transition name="fade">
    <div class="loginModal" v-if="show" :class="{fromGame: fromGame}">
      <div class="overlay" v-on:click="close"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close"></div>
        <div class="successCnt" v-if="success">
          <div class="success-animation">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"><circle class="checkmark__circle"
              cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check"
              fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
          </div>
        </div>
        <div v-else>
          <h4>Dukung {{d.name}}</h4>
          <div class="formCnt">
            <p v-if="viewMore">{{d.profile}}</p>
            <p v-else>{{d.profileShort}}</p>
            <div class="viewMore" v-on:click="viewMore = false"
              v-if="viewMore">Lihat lebih sedikit</div>
            <div class="viewMore" v-on:click="viewMore = true" v-else>Lihat lebih banyak</div>
            <h4>Saya/organisasi saya/perusahaan saya ingin memberikan dukungan dalam bentuk</h4>
            <div class="formItem" :class="{hasError: itemError}">
              <div class="checkCnt" :class="{checked: item.checked}"
                v-for="(item, i) in formItems" :key="`fi${i}`"
                v-on:click="item.checked = !item.checked; itemError = null">
                <div class="checkboxOuter">
                  <div class="checkbox" :class="{checked: item.checked}"></div>
                </div>
                {{item.label}}
              </div>
              <div class="fieldError" v-if="itemError">{{itemError}}</div>
            </div>
            <div class="fieldGroup" :class="{hasError: form.email.error}">
              <label>Your Email</label>
              <input type="email" placeholder="Type your email..." class="field"
                v-model="form.email.model" v-on:input="form.email.error = null">
              <div class="fieldError" v-if="form.email.error">{{form.email.error}}</div>
            </div>
          </div>
          <div class="modalFooter">
            <button class="secondary" v-on:click="close(false)">Batal</button>
            <button :class="{btnLoading: loading}"
              v-on:click="handleSubmit"><span>Kirim Pesan</span></button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      success: false,
      show: false,
      loading: false,
      viewMore: false,
      next: null,
      d: null,
      fromGame: false,
      formItems: [],
      itemError: null,
      form: {
        email: { model: '', error: null },
      },
    };
  },
  methods: {
    close(ok) {
      this.show = false;
      document.querySelector('body').classList.remove('ofw-hdn');
      if (this.next) this.next(ok);
    },
    open(d, n) {
      this.d = d;
      this.form.email.model = this.$session.get('tufi2_email') || '';
      this.form.email.error = null;
      this.formItems = [
        { checked: false, label: 'Kemungkinan kolaborasi' },
        { checked: false, label: 'Dana' },
        { checked: false, label: 'Pemberitaan di media' },
        { checked: false, label: 'Lain-lain' },
      ];
      this.next = n;
      this.show = true;
      this.loading = false;
      this.success = false;
      document.querySelector('body').classList.add('ofw-hdn');
    },
    handleSubmit() {
      if (!this.d || this.loading) return;
      let noCheck = true;
      // eslint-disable-next-line
      for (const item of this.formItems) {
        if (item.checked) noCheck = false;
      }
      if (noCheck) {
        this.itemError = 'Pilih minimal satu tipe dukungan';
        return;
      }
      if (!this.form.email.model || this.form.email.model === '') {
        this.form.email.error = 'Alamat email dibutuhkan untuk membalas pesan kamu';
        return;
      }
      if (!(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.form.email.model))) {
        this.form.email.error = 'Alamat email tidak valid';
        return;
      }
      this.loading = true;
      // grecaptcha.ready(() => {
      //   grecaptcha.execute('6LcU0fsgAAAAAL4epshQPCoGSc0jky8Dcuy9Qoqw', {
      //     action: 'submit',
      //   }).then((token) => {
      //     // Add your logic to submit to your backend server here.
      //     console.log(token); //eslint-disable-line
      //   });
      // });
      this.$http.post(this.$config.uri(`misc/profile/${this.d.id}/contact`), {
        email: this.form.email.model,
        items: this.formItems,
      }).then((r) => {
        this.success = true;
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.loginModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 1;
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background-color: #fff;
    // background-color: #e6e1c1;
    // background-image: url(../assets/modal-bg.jpg);
    background-size: auto 100%;
    background-position: right;
    background-repeat: no-repeat;
    margin: auto;
    border-radius: 5px;
    padding: 40px 60px;
    width: 520px;
    .close{
      position: absolute;
      right: 10px; top: 10px;
      width: 40px; height: 40px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .4;
      cursor: pointer;
      transition: all .2s ease;
      &:hover{
        background-color: #e9e9e9;
        opacity: .8;
      }
    }
    h4{
      margin: 0 0 4px;
      font-size: 20px;
      font-family: 'GolosUIWebBold', sans-serif;
    }
    .formCnt{
      .fieldError{
        margin-left: 2px;
      }
      .formItem{
        padding-left: 7px;
        &.hasError{
          .checkCnt .checkbox{
            border-color: red;
          }
        }
        .fieldError{
          color: #ff7979;
          font-size: 12px;
          margin: 6px 0 0 -4px;
        }
      }
      h4{
        font-family: 'GolosUIWebRegular', sans-serif;
        font-size: 17px;
        border-top: #eee 1px solid;
        padding-top: 10px;
      }
      p{
        margin: 0;
      }
      .viewMore{
        display: inline-block;
        margin-top: 6px;
        cursor: pointer;
        color: #5351a4;
        color: #fff;
        background-color: #5351a4;
        font-size: 14px;
        padding: 4px 12px;
        border-radius: 50px;
        margin-bottom: 10px;
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
        }
      }
      .fieldGroup{
        padding-top: 14px;
      }
    }
    @media (max-width: 680px){
      position: absolute;
      top: 50%; left: 10px; right: 10px;
      transform: translateY(-50%);
      font-size: 15px;
      padding: 30px 30px 50px;
      width: auto;
    }
    .modalFooter{
      margin: 0 -60px -20px;
      text-align: right;
      border-top: #eee 1px solid;
      padding: 10px 60px 0;
      @media (max-width: 680px){
        margin: 0 -30px -40px;
        padding: 10px 30px 0;
      }
      button{
        margin-left: 5px;
      }
    }
  }
}

.success-animation {
  margin: 150px auto;
  @media (max-width: 680px) {
    margin: 100px auto;
  }
}
.checkmark {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #4bb71b;
  stroke-miterlimit: 10;
  box-shadow: inset 0px 0px 0px #4bb71b;
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  position:relative;
  top: 5px;
  right: 5px;
  margin: 0 auto;
}
.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #4bb71b;
  fill: #fff;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%, 100% {
    transform: none;
  }

  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #4bb71b;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
